export default __webpack_public_path__ + "static/media/dustbin-off.0dee4ff8.svg";